import { Documentation } from "../../../common/store/generalTypes";
import { BasicProps } from "@components/ComponentsInterface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay, faFile } from "@fortawesome/free-regular-svg-icons";

export const DocumentList = ({ documents, isDocument }: DocumentListProps): JSX.Element => {
    const getFileName = (url: string): string => {
        // TODO: find a better way
        const file = url.split("/");
        const fileName = file[file.length - 1].split(".");

        fileName.pop();

        return fileName[0];
    };

    return (
        <div className="has-background-success-light pt-4 px-6">
            {documents.map((doc) => {
                return (
                    <div key={doc.id} className="pb-4">
                        <div className="has-text-grey-darker has-text-weight-semibold pb-2">{doc.title}</div>
                        <div className="pb-2">{doc.description}</div>
                        <div className="columns">
                            <div className="column pr-0">
                                <div className="has-text-right has-text-link">
                                    {isDocument && <FontAwesomeIcon icon={faFile} size="lg" />}
                                    {!isDocument && <FontAwesomeIcon icon={faCirclePlay} size="lg" />}
                                </div>
                            </div>
                            <div className="column is-full">
                                <a className="is-underlined" href={doc.fileUrl} target="_blank" rel="noreferrer">
                                    {getFileName(doc.fileUrl)}
                                </a>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

interface DocumentListProps extends BasicProps {
    documents: Documentation[];
    isDocument?: boolean;
}
